export default __webpack_public_path__ + "static/minvideo-7520e90e8d47849a214f21b69857ead0.mp4";